<template>
	<section class="newsletter-section">
		<div class="row">
			<div class="columns column4 align-center">
				<div class="inner-content">
					<h2 class="subtitle">{{ subtitle }}</h2>
					<h2>{{ header }}</h2>
					<div v-parse-links v-html="content" />

					<div id="mc_embed_shell">
						<div id="mc_embed_signup">
							<form
								id="mc-embedded-subscribe-form"
								action="https://finehotelsandsuites.us14.list-manage.com/subscribe/post?u=3a88790fc5cebb4a8afabab5b&amp;id=62879cf8de&amp;f_id=008db5e5f0"
								method="post"
								name="mc-embedded-subscribe-form"
								class="newsletter validate"
								target="_blank"
							>
								<div id="mce-responses" class="clear">
									<div id="mce-error-response" class="response" style="display: none"></div>
									<div id="mce-success-response" class="response" style="display: none"></div>
								</div>
								<div aria-hidden="true" style="position: absolute; left: -5000px">
									<input
										type="text"
										name="b_3a88790fc5cebb4a8afabab5b_62879cf8de"
										tabindex="-1"
										value=""
									/>
								</div>
								<div class="clear"></div>
								<input
									id="mce-EMAIL"
									type="email"
									name="EMAIL"
									class="required email"
									required=""
									value=""
									:placeholder="$t('formEmail')"
								/>
								<input
									id="mc-embedded-subscribe"
									type="submit"
									name="subscribe"
									class="button"
									:value="button"
								/>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
		<picture>
			<source :srcset="imageWebp" type="image/webp" />
			<source :srcset="image" />
			<img class="bg-image" :src="image" :alt="imageAlt" loading="lazy" />
		</picture>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: '' },
	image: { type: String, default: '' },
	imageWebp: { type: String, default: '' },
	imageAlt: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.newsletter-section {
	background: var(--primary-background-color);
	position: relative;
	overflow: hidden;
	padding: 120px 0 80px;
	border-bottom: none;

	.row {
		justify-content: flex-end;
	}

	h2 {
		font-family: var(--body-font-family);
	}

	.column4 {
		position: relative;
		z-index: 2;
		margin-right: 40px;

		&::before {
			content: '';
			display: block;
			background: var(--secondary-background-color);
			inset: 40px 40px 0 20px;
			position: absolute;
			z-index: 1;
		}

		.inner-content {
			position: relative;
			z-index: 2;
			width: 100%;
			margin: 0 0 40px 40px;
			padding: 60px 40px;
			background: #fff;
		}

		ul {
			list-style-type: none;

			li {
				display: flex;
				flex-flow: row nowrap;
				justify-content: flex-start;
				align-items: center;

				&::before {
					content: '';
					display: block;
					width: 30px;
					height: 30px;
					background: url('~/assets/images/list-icon-green.svg') no-repeat center center;
					background-size: 100%;
					margin: 0 15px 0 0;
				}
			}
		}
	}

	.bg-image {
		position: absolute;
		z-index: 1;
		inset: 0 30vw 0 0;
		width: 70vw;
		height: 100%;
		object-fit: cover;
	}

	.book-now {
		margin: 30px auto 0;
	}

	svg {
		margin: 0 auto 20px;
		color: var(--cta-color);
		font-size: 40px;
	}

	h2,
	h3 {
		margin: 0 0 20px;
	}

	form {
		margin-top: 30px;
		display: flex;
		flex-flow: row wrap;
		align-items: center;
		justify-content: flex-start;
		gap: 0;

		input {
			background: none;
			padding: 15px;
			height: 52px;
			border: 1px solid var(--cta-color);
			width: 54%;
			max-width: 300px;
			vertical-align: top;
			text-transform: uppercase;
			font-weight: 600;

			&::placeholder {
				color: #333;
			}

			&.button {
				line-height: 22px;
				margin: 0;
				padding: 14px 30px;
				background: var(--cta-color);
				color: #fff;
				width: 46%;
				border: none;

				&:hover {
					background: var(--cta-color-hover);
					color: #fff;
				}
			}
		}
	}
}

@media (max-width: 880px) {
	.newsletter-section {
		padding: 75px 0;

		.column4 {
			width: 100%;
			margin-right: 0;

			.inner-content {
				width: calc(100% - 40px);
			}
		}

		.bg-image {
			width: 100%;
			position: relative;
			inset: auto;
			margin: -40px 0 40px;
			height: auto;
		}
	}
}

@media (max-width: 600px) {
	.newsletter-section {
		form {
			width: 100%;

			input {
				width: 100%;
				max-width: 100%;

				&.button {
					width: 100%;
				}
			}
		}
	}
}
</style>
